/**
 * Selection Store Module
 *
 * Manages UI selection state for homes, rooms, devices, and gateways
 * Provides smart selection with automatic context relationships
 */

import { Module } from 'vuex';
import type { RootState } from '@/store/types';
import mutations, { initialSelectionState, SelectionState } from './mutations';
import getters from './getters';
import actions from './actions';

const selectionModule: Module<SelectionState, RootState> = {
  namespaced: true,
  state: initialSelectionState,
  mutations,
  getters,
  actions,
};

export default selectionModule;


